
export const CONFIRMED_DELETE_PATIENT_ACTION = "CONFIRMED_DELETE_PATIENT_ACTION";
export const CONFIRMED_EDIT_PATIENT_ACTION = "CONFIRMED_EDIT_PATIENT_ACTION";
export const CONFIRMED_GET_PATIENTS = "CONFIRMED_GET_PATIENTS";
export const CONFIRMED_GET_PATIENT_DETAILS= "CONFIRMED_GET_PATIENT_DETAILS";
export const CONFIRMED_GET_PATIENTS_BY_GENDER = "CONFIRMED_GET_PATIENTS_BY_GENDER";
export const CONFIRMED_ADD_MARRIAGE_INFO = "CONFIRMED_ADD_MARRIAGE_INFO"
export const CONFIRMED_ADD_ADDRESS_INFO = "CONFIRMED_ADD_ADDRESS_INFO"
export const CONFIRMED_ADD_OTHER_INFO = "CONFIRMED_ADD_OTHER_INFO"
export const CONFIRMED_CREATE_PATIENT_ACTION = "CONFIRMED_CREATE_PATIENT_ACTION"
export const FETCH_FAMILY_TREE_LIST_SUCCESS = "FETCH_FAMILY_TREE_LIST_SUCCESS"
export const CONFIRMED_ADD_FAMILY_TREE = "CONFIRMED_ADD_FAMILY_TREE"
export const CONFIRMED_EDIT_FAMILY_TREE = "CONFIRMED_EDIT_FAMILY_TREE"
export const CONFIRMED_DELETE_FAMILY_TREE = "CONFIRMED_DELETE_FAMILY_TREE"